import { useContext } from 'react';
import { AreaContext } from '../../contexts/AreaContextProvider';

const useAreaContext = () => {
  return useContext(AreaContext);
};

export default useAreaContext;
